module.exports = __webpack_public_path__ + "static/media/facebook.422e7665.svg";